import moment from "moment";

export const TAG_COLOR_ROLE = {
	"Volunteer Coordinator": "blue",
	Volunteer: "green",
	Patient: "orange",
	AIDE: "gold",
	RN: "purple",
	"INTAKE COORDINATOR": "pink",
	"SOCIAL WORKER": "cyan",
	CHAPLAIN: "red",
	"SCHEDULING COORDINATOR": "yellow",
	LPN: "pink",
};

export const TAG_COLOR_INVITE_STATUS = {
	Invited: "blue",
	Onboarded: "green",
	Revoked: "orange",
};

export const statusPromptText = {
	Accepted: "Accepted",
	Started: "Started",
	Completed: "Pending Approval",
	Approved: "Approved",
	Rejected: "Rejected",
	// Assigned: {
	// 	Volunteer: "Assigned To You",
	// 	"Volunteer Coordinator": "Assigned"
	// },
	Assigned: "Assigned",
	Opportunity: "Open Opportunity",
	Filled: "Form Saved",
	Edited: "Pending Approval"
}

export const metaDataKeys = {
	comments: "Comment",
	language: "English"
}

export const disabledDate = (current) => {
	return current && current < moment().subtract(3, 'days').startOf('day');
};

export const disabledFutureDate = (current) => {
    return current && current > moment().endOf('day');
};

export const getFullName = (firstName, lastName) => {
    const capitalize = (name) => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

    const formattedFirstName = firstName ? capitalize(firstName) : "";
    const formattedLastName = lastName ? capitalize(lastName) : "";

    return [formattedFirstName, formattedLastName].filter(Boolean).join(" ") || null;
};